export const LIST_STORE_AGENTS_ERROR = 'LIST_STORE_AGENTS_ERROR';
export const LIST_STORE_AGENTS_SUCCESS = 'LIST_STORE_AGENTS_SUCCESS';
export const LIST_STORE_AGENTS_START = 'LIST_STORE_AGENTS_START';
